const classNames = {
    pagingContainer:"flex grid grid-cols-4 leading-6 font-medium",
    pagingCount:"text-center py-2 px-4 align-middle w-96",
    pagingNextBtn:"bg-purple-500 hover:bg-purple-700 text-white w-8 h-8 font-bold border border-purple-700 rounded-r-md",
    pagingPrevBtn:"bg-purple-500 hover:bg-purple-700 text-white w-8 h-8 font-bold border border-purple-700 rounded-l-md",
    resultsGrid:"p-8 pt-32 grid grid-cols-5 gap-4 bg-purple-50",
    searchResult:"cursor-pointer px-0 shadow-md rounded-lg bg-white border border-purple-300",
    searchResultImage:"rounded-t-lg min-w-full bg-white",
    searchResultName:"text-center pb-4 pt-4 rounded-b-lg bg-white text-purple-400",
    searchInput:"form-input px-4 py-2 h-8 rounded-l-md",
    searchBtn:"mr-4 bg-purple-500 hover:bg-purple-700 text-white font-bold px-4 h-8 border border-purple-700 rounded-r-md",
    searchControls:"bg-gray-100 border border-purple-500 shadow-md py-4 px-4 rounded-lg bg-white fixed ml-16 mt-4 w-1/2",
    searchResultDetail:"p-8 pt-32 grid grid-cols-2 w-1/2 gap-4 bg-purple-50",
    searchResultDetailBio:"whitespace-pre-wrap text-gray-700 border-t border-b border-gray-300 py-4",
    searchResultDetailImage:"w-64 rounded-lg border border-purple-300 shadow-md",
    searchResultUsername:"font-bold text-purple-700",
    searchResultDetailLabel:"",
    searchResultDetailValue:"",
    searchResultDetailIcon:"",
    searchResultDetailData:"p-4 shadow-md rounded-lg bg-white",
    errorMessage:"w-full text-center text-red-500",
}
export default classNames;